import { createSlice } from '@reduxjs/toolkit';

const initialCalendarState = {
  appointments: [],
  loading: false,
  currentDate: new Date().toISOString(),
  currentViewName: 'Day'
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState: initialCalendarState,
  reducers: {
    setData(state, action) {
      state.appointments = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
    setCurrentViewName(state, action) {
      state.currentViewName = action.payload;
    }
  }
});

export const calendarActions = calendarSlice.actions;

export default calendarSlice.reducer;
